export const C = {
  bg0:'#010810', bg1:'#040D18', bg2:'#071422', bg3:'#0A1B2E',
  line:'#122840', line2:'#1A3550',
  teal:'#0FA3B1', tealBright:'#1FC8D6', tealDeep:'#0A7B86',
  s1:'#DCE4E8', s2:'#AEBCC3', s3:'#7C8E97', s4:'#4A6070',
  paper:'#F2F7F9', paper2:'#E5EFF3', ink:'#0A2028', ink2:'#3C545F', muted:'#6F858E',
}

export const fmt = n => Math.round(n).toLocaleString('ru-RU')
